import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis } from "../utils/useLenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }

        const lenis = getLenis();
        const currentPath = pathname; // ← capture at effect time

        ScrollTrigger.getAll().forEach((t) => t.kill());
        ScrollTrigger.clearScrollMemory();

        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        if (lenis) {
            lenis.scrollTo(0, { immediate: true, force: true });
        }

        const timer = setTimeout(() => {
            // ← skip refresh if user already navigated away
            if (window.location.pathname !== currentPath) return;
            ScrollTrigger.refresh(true);
        }, 200);

        return () => clearTimeout(timer);
    }, [pathname]);

    return null;
}